(function () {
	'use strict';

  // THIS COULD BE REPLACED WITH <script src="j/sticky-bar.js"></script> AFTER FILE USES SNIPPET FOR FOOTER JS
	var detectedOS = avastGlobals.detect.os.name.toLowerCase(),
    $window = $(window),
    $buttons = $('.sticky-bar a'),
    waypoints = avm.require('avast.web.waypoints'),
    platformDetectionSelector = '#sticky-bar-platform-detect'

  $buttons.attr("tabindex",-1);

  if ($('.sticky-bar').length) {
    $window.on('resize scroll', function () {
      if (waypoints($('.sticky-waypoint'), null, null, true)) {
        $('.sticky-bar').addClass('is-sticky');
        $buttons.attr("tabindex",0);
      } else {
        $('.sticky-bar').removeClass('is-sticky');
        $buttons.attr("tabindex",-1);
      }
    });

    $buttons.filter('[href^="#"]').on('click', function(e) {
      e.preventDefault()
      var targetSection = $($(this).attr('href'))
      $('html, body').animate({
        scrollTop: targetSection.length ? targetSection.offset().top : 0,
      })
    })
  }


  if ($(platformDetectionSelector).length) {
    var app = new Vue({
      el: platformDetectionSelector,
      delimiters: ["<%", "%>"],
      data: {
        detectedOS: detectedOS,
      }
    })
  }
  // end of possible code removal


})();
